import React from "react";
import {GatsbyImage, StaticImage} from "gatsby-plugin-image";

const ImageGridBanner = (
  {
    className = "",
    imageData = null,
    children,
  }
) => {
  return (
    <section className={`image-grid-banner ${className}`}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="image-grid-banner__image-wrapper">
              {imageData ? (
                <GatsbyImage
                  className="image-grid-banner__image"
                  image={imageData}
                  alt="Evo"
                />
              ) : (
                <StaticImage
                  className="image-grid-banner__image"
                  src="https://via.placeholder.com/1920x1000"
                  alt="EVO"
                  quality="60"
                  layout="fullWidth"
                />
              )}
            </div>
            {children && (
              <div className="image-grid-banner__children mt-3 text-center">{children}</div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ImageGridBanner
